export default __webpack_public_path__ + "static/media/logo.b871267b.svg";